import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FacturasService {
  public tramite;
  public totales;
  public factura;
  public facturaActual = 1;
  public totalFacturas = 0;
  public renglones;
  public renglonesFacturaNueva;
  public modulo;
  public blockActions = false;
  public estadoTemporal = {
    descripcion: null,
    color: null,
  };
  public catalogos = {
    conceptos: null,
    coberturas: null,
    motivoRechazo: null,
    motivoDevolucion: null,
    motivoDesvio: null,
    subsecuentes: null,
    tipoDescuento: null,
  };
  public totalesFacturaNueva = {
    subtotal: 0,
    descuento: 0,
    tipoDescuento: null,
    iva: 0,
    retencionIva: 0,
    islr: 0,
    total: 0,
  };

  constructor() {}
}
